module.exports = __webpack_public_path__ + "img/weixin_gray.bead522f.png";